import React from "react";
import stepImg from "../../images/hireDeveloper/stepImg.png";

const stepData = [
  {
    no: 1,
    heading: "Fill up the form",
    text: "Fill in your basic details like name, email, skills, etc.",
  },
  {
    no: 2,
    heading: "Take our test and interview",
    text: "Answer a few questions to get qualified for a technical interview.",
  },
  {
    no: 3,
    heading: "Receive job offers",
    text: "Get in touch with the best companies globally.",
  },
  {
    no: 4,
    heading: "Start working on your dream job",
    text: "Match with their preferences and get hired.",
  },
];

const HireSteps = () => {
  return (
    <>
      <section className="hireStepSection">
        <div className="container">
          <div className="row align-items-end align-items-lg-center">
            <div className="col-lg-5 col-md-12">
              <div className="heading" data-aos="slide-right">
                <h3>
                  <span>Who Can Apply To</span> The Hire Remote Team?
                </h3>
              </div>
              <div className="box" data-aos="slide-right">
                <img src={stepImg} alt="hire android app developer" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 ml-auto">
              <div className="row">
                <div className="col-md-12">
                  <div className="title" data-aos="slide-up">
                    <h5>
                      <span>4 Easy Steps</span>
                    </h5>
                  </div>
                </div>
                {stepData.map((each, i) => (
                  <div
                    className="col-lg-6 col-md-6 col-sm-6 mb-5 txt"
                    data-aos="slide-up"
                    key={i}
                  >
                    <div className="details">
                      <span>{each.no}</span>
                      <h6>{each.heading}</h6>
                      <p>{each.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HireSteps;
